import { computed } from 'mobx';
import ApiModel     from './globals/ApiModel';

export default class ReportModel extends ApiModel {
  static get path() {
    return '/backend/reports/{?id}';
  }

  static get defaults() {
    return {
      attachments: [],
    };
  }

  @computed
  get comment() {
    return this.get('comment', '');
  }

  @computed
  get name() {
    return this.get('name', '');
  }

  @computed
  get status() {
    return this.get('status', '');
  }
}
